@if (!title()) {
    <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>{{ icon() }}</mat-icon>
    </button>
} @else {
    <button mat-button [matMenuTriggerFor]="menu">
        @if (!!icon()) {
            <mat-icon>{{ icon() }}</mat-icon>
            &nbsp;
        }
        {{ title() | translate }}
    </button>
}

<mat-menu #menu="matMenu">
    <ng-content />
</mat-menu>
